import React from 'react';
import { useSelector } from 'react-redux';

import { Page } from 'ui/components';
import {
  SkeletonTable,
  SkeletonPageFooter,
} from 'ui/components/skeleton';
import useTable from 'ui/components/table';

import tableConfig from './component/table/config';

const CustomerScreen = () => {
  const CustomerTable = useTable('customer', tableConfig);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );

  return (
    <Page className="fixed ">
      <Page.Header
        pretitle="Daftar"
        className="bg-white"
        title={'Customer'}
        isLoading={StateLoading}
        action={false}
      />

      <Page.Navigation toolbar>
        <CustomerTable.Tools downloadable isLoading={StateLoading} />
      </Page.Navigation>

      <Page.Body className="row m-0 p-0">
        <div
          className='col-md-12 m-0 p-0'
        >
          {StateLoading ? (
            <SkeletonTable headerCount={9} bodyCount={9} />
          ) : (
            <CustomerTable.Render />
          )}
        </div>
      </Page.Body>
      <Page.Footer>
        {StateLoading ? <SkeletonPageFooter /> : <CustomerTable.Pagination />}
      </Page.Footer>
    </Page>
  );
};

export default CustomerScreen;
